export const getEllipsisText = (text: any) => {
  if (text.length < 15) {
    return text;
  }

  return text.substring(0, 15) + '...';
};
